export default __webpack_public_path__ + "static/media/bg5.6232e8af.jpg";